// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__qhbJk","clickedWithMouse":"MenuLabel_clickedWithMouse__3QMp-","isOpen":"MenuLabel_isOpen__1gISq"};